import { Share, ShareImage } from '@zhenguo/types'
import { I_SHARECONFIG, T_SHARECONFIG, T_SHAREIMAGECONFIG } from './types'

function processShareOptions<U, T extends I_SHARECONFIG<U>>(method: string, options: T): [string, T] {
  if (!options.channel) {
    options.channel = ['WECHAT_FRIENDS', 'WECHAT_TIMELINE']
  }
  if (typeof options.channel === 'string') {
    if (method === 'shareImage') {
      const channel = options.channel as keyof typeof ShareImage
      return [
        method,
        {
          ...options,
          channel: window.KNB && window.KNB.shareImage[channel],
        },
      ]
    }
    const channel = options.channel as keyof typeof Share
    return [method, { ...options, channel: window.KNB && window.KNB.share[channel] }]
  } else if (Array.isArray(options.channel)) {
    // ios 为 number，安卓 为 字符串
    const newChannel = (options.channel as (keyof typeof ShareImage | keyof typeof Share)[]).map(
      (channel): string | number | undefined => window.KNB && window.KNB.share[channel],
    ) as string[] | number[]
    return [
      method,
      {
        ...options,
        channel: newChannel,
      },
    ]
  }
  return [method, options]
}

export default function processOptions(method: string, options: any): [string, any] {
  const isShare = method.toLowerCase().indexOf('share') !== -1
  if (isShare) {
    if (method === 'shareImage') {
      return processShareOptions<ShareImage, T_SHAREIMAGECONFIG>(method, options)
    }
    return processShareOptions<Share, T_SHARECONFIG>(method, options)
  }
  return [method, options]
}
